import type {DataValue, NameVariantValue} from '../types';

export const isNameVariantValue = (
  value: DataValue | undefined,
): value is NameVariantValue =>
  value !== undefined &&
  value !== null &&
  !Array.isArray(value) &&
  typeof value === 'object';
